<template>
  <v-layout class="ld-nav-bar ld-nav-bar-menu">
    <!-- Nav button two - About -->
    <v-flex class="xs3 ld-inline-block">
      <div class="ld-nav-bar-item" slot="activator" @click="onClickNav1">
        <div class="ld-nav-text">Milk Tea</div>
      </div>
    </v-flex>
    <!-- Nav button three - Menu -->
    <v-flex class="xs3 ld-inline-block">
      <div class="ld-nav-bar-item" slot="activator" @click="onClickNav2">
        <div class="ld-nav-text">Iced Tea</div>
      </div>
    </v-flex>
    <!-- Nav button four - Gallery -->
    <v-flex class="xs3 ld-inline-block">
      <div class="ld-nav-bar-item" slot="activator" @click="onClickNav3">
        <div class="ld-nav-text">Slush - Snow</div>
      </div>
    </v-flex>
    <!-- Nav button one - Contact -->
    <v-flex class="xs3 ld-inline-block">
      <div class="ld-nav-bar-item" slot="activator" @click="onClickNav4">
        <div class="ld-nav-text">Add-ins</div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    methods: {
      onClickNav1: function(element) {
        this.$emit('onClickNav1', element);
      },

      onClickNav2: function(element) {
        this.$emit('onClickNav2', element);
      },

      onClickNav3: function(element) {
        this.$emit('onClickNav3', element);
      },

      onClickNav4: function(element) {
        this.$emit('onClickNav4', element);
      },

      onClickNav5: function(element) {
        this.$emit('onClickNav5', element);
      }
    },

    name: 'navigationMenuComponent',

    data() {
      return {};
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/navigation_menu_component.vue